<template>
  <el-container :style="bgStyles" class="auth">
    <el-col :xs="20" :sm="12" :md="12" :lg="8" :xl="6">
      <el-row v-if="course.logo" class="auth-logo">
        <img :src="course.logo" alt="Logo">
      </el-row>
      <el-row class="auth-form">
        <div class="title">Login to the members area</div>
        <el-input v-model="form.email" placeholder="Your email"/>
        <el-input v-model="form.password" type="password" placeholder="Password"/>
        <el-button
          :loading="loading"
          :disabled="loading"
          type="success"
          @click="login">
          LOGIN
        </el-button>
        <!-- <router-link to="/registration" class="not-a-member">
          <img src="/lock-gray.png" alt="lock image">
          not a member?
        </router-link> -->
      </el-row>
    </el-col>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    loading: false,
    form: {
      email: '',
      password: '',
    },
  }),
  computed: {
    ...mapGetters(['course']),
    bgStyles() {
      const bg = this.course['auth-background'];

      if (bg.includes('http')) {
        return { 'background-image': `url("${bg}")` };
      }

      return {};
    },
  },
  methods: {
    login() {
      this.loading = true;
      window.http.post('/login', this.form)
        .then((response) => {
          if (response.data.status === 'success') {
            localStorage.setItem('jwtToken', response.data.token);
            this.$router.push('/module-1');
          } else {
            this.$notify({
              type: 'error',
              text: response.data.message,
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          this.$notify({
            type: 'error',
            text: error.data.message,
            duration: 2000,
          });
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>
